import React from 'react'
import './input-modal-component.scss'

interface InputModalProps {
  children?: React.ReactNode
  testId?: string
  /** Merged onto `modal-container` (e.g. theme overrides for a flow) */
  className?: string
  onBackdropClick?: () => void
}

function InputModal({ children, testId, className = '', onBackdropClick }: InputModalProps) {
  return (
    <div
      className={`modal-container ${className}`.trim()}
      data-testid={testId}
      role='presentation'
      onClick={(e) => {
        if (e.target === e.currentTarget) onBackdropClick?.()
      }}
    >
      {onBackdropClick ? <div onClick={(e) => e.stopPropagation()}>{children}</div> : children}
    </div>
  )
}

export { InputModal }
